import { ZebraLabelType } from '@services/barcode/ZebraLabelType';

// Response defined in IhmCandyCanePieces
// https://tiny.amazon.com/2iu82dn9/codeamazpackIhmCbloba82dpiec
export interface IBarcodeScanResult {
    scanned: string;
    scannedType: ZebraLabelType;
}

export const parseBarcodeScannerResult = (response: any): IBarcodeScanResult => {
    const result = response as IBarcodeScanResult;

    if (!response.scanned) {
        throw new Error(`Could not parse 'scanned' from response: ${response}`);
    }

    // Fallback to LABEL-TYPE-UNDEFINED if the scannedType is not a valid value
    if (!Object.values(ZebraLabelType).includes(result.scannedType)) {
        result.scannedType = ZebraLabelType['LABEL-TYPE-UNDEFINED'];
        console.error(`Wrongly formatted scannedType in ${response}`);
    }

    return result;
};
